module.exports = __webpack_public_path__ + "img/plan.9b3bb703.png";